import React, { useEffect } from 'react';
import "./CurrentSubscription.css";
import { useDispatch, useSelector } from 'react-redux';
import { viewPlanList } from '../../Redux/Actions/subscriptionActions';

const PlanCard = ({
  name,
  originalPrice,
  discountedPrice,
  isActive = false,
  isMostPopular = false,
  onActionClick,
  actionLabel = "Subscribe",
  features = [],
  type,
}) => {
  return (
    <div className={`plan-card ${type} ${isActive ? "active-plan" : ""}`}>
      {isMostPopular && <div className="badge">Most Popular</div>}
      <h3>{name}</h3>
      <p className="original-price">{originalPrice}</p>
      <p className="discounted-price">{discountedPrice} <span>/90 Days</span></p>
      <button className={`btn ${isActive ? "active" : "subscribe"}`} onClick={onActionClick}>
        {isActive ? "Active" : actionLabel}
      </button>
      <ul>
        {features?.map((feature, i) => (
          <li key={i}>
            {feature.status ? "✅" : "❌"} {feature.label}
          </li>
        ))}
      </ul>
    </div>
  );
};



const CurrentSubscription = ({ data }) => {

  const dispatch = useDispatch();

  useEffect(() => {
    const planData = {
      page: 1,
      limit: 10,
      status: ["active", "inactive"]

    };
    dispatch(viewPlanList(planData));
  }, [])
  const planList = useSelector((state) => state.subscription)
  const planFeatures = data?.features
    ?.filter(item => item.status === true)
    ?.map(item => {
      const keys = Object.keys(item).filter(k => k !== "status");
      return item[keys[0]];
    });


  const calculateRenewalDate = (startDate, interval, intervalType) => {
    if (!startDate || !interval || !intervalType) return null;

    const date = new Date(startDate);

    switch (intervalType) {
      case "DAY":
        date.setDate(date.getDate() + interval);
        break;
      case "months":
        date.setMonth(date.getMonth() + interval);
        break;
      case "years":
        date.setFullYear(date.getFullYear() + interval);
        break;
      default:
        return null;
    }

    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };
  const renewalDate = calculateRenewalDate(
    data?.created_at,
    data?.plan_intervals,
    data?.plan_interval_type
  );

  return (
    <div className="subscription-container">
      {data &&
        <>
          <h2 className="subscription-heading">Subscriptions</h2>
          <div className="plan-first-section">
            <div className="current-plan-card">
              <div className="plan-summary">
                <div className="plan-summary-current">
                  <div className="plan-heading-current">
                    <span className="current-plan">Current Plan</span>
                    <span className='current-plan-name'>{data?.plan_name}</span>
                  </div>
                  <div>
                    <p className="price">{data?.plan_recurring_amount
                    } <span>/{
                      data?.plan_intervals
                    } {data?.
                      plan_interval_type}</span></p>
                    <span className="status active">● {data?.status}</span>
                  </div>
                </div>
                <div className="plan-actions">
                  <button className="btn cancel">Cancel Subscription</button>
                  <button className="btn upgrade">Upgrade Plan</button>
                </div>
              </div>
              <div className="renewal-text">
                Your <strong>{data?.plan_name}</strong> subscription renews automatically on{" "}
                <strong>{renewalDate || "—"}</strong> and you'll be billed{" "}
                <strong>{
                  data?.plan_currency
                }{data?.plan_recurring_amount}</strong>.
              </div>
            </div>

            <div className="plan-includes">
              <span className='plan-includes-span'>This Plan includes:</span>
              <div className="scrollable-list">
                <ul>
                  {planFeatures?.map((item, i) => (
                    <li key={i}>✅ {item}</li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
        </>
      }
      <h3 className="all-plans-heading">All Plans</h3>
      <div className="plans-grid">
        {planList?.plan?.data?.map((plan) => {
          const {
            plan_name,
            before_discount_amount,
            plan_recurring_amount,
            is_most_popular,
            plan_name_withoutspace,
            status,
            features,
          } = plan;

          const formattedFeatures = features?.map((item) => {
            const key = Object.keys(item).find((k) => k !== "status");
            return {
              label: item[key],
              status: item.status === true,
            };
          });
          return (
            <PlanCard
              key={plan._id}
              name={`${plan_name} Plan`}
              originalPrice={`₹${before_discount_amount}`}
              discountedPrice={`₹${plan_recurring_amount}`}
              isActive={status === "active"}
              isMostPopular={is_most_popular}
              features={formattedFeatures}
              type={plan_name_withoutspace.toLowerCase()}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CurrentSubscription;
